export const WWW_ORIGIN = "https://www.metal.com"

export const ORGANIZATION_ID = `${WWW_ORIGIN}/#organization`
export const WEBSITE_ID = `${WWW_ORIGIN}/#website`
